import { Routes } from '@angular/router';
import { loggedIn } from '@features/auth/infrastructure/guards/session-guards';
import { pageAccess } from '@features/auth/infrastructure/guards/page-access-guard';
import { RegisterPageComponent } from '@features/auth/infrastructure/pages/register-page/register-page.component';
import { RootComponent } from './components/root/root.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/infrastructure/pages/auth-pages-routing.module'),
    // canActivate: [loggedOut],
  },
  {
    path: 'permissions',
    loadChildren: () => import('./features/permissions/infrastructure/pages/permissions-pages-routing.module'),
  },
  {
    path: 'register/:role',
    component: RegisterPageComponent,
  },
  {
    path: 'register',
    component: RegisterPageComponent,
  },
  {
    path: 'help',
    loadComponent: () => import('src/app/components/help/help.component')
      .then(c => c.HelpComponent),
  },
  {
    path: '',
    component: RootComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'home',
        loadComponent: () => import('src/app/components/home/home.component')
          .then(c => c.HomeComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'dashboard',
        loadComponent: () => import('src/app/components/dashboard/dashboard.component')
          .then(c => c.DashboardComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'languages',
        loadComponent: () => import('src/app/components/languages/languages.component')
          .then(c => c.LanguagesComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'profile',
        title: 'Profile',
        loadComponent: () => import('src/app/components/profile/profile.component')
          .then(c => c.ProfileComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'users',
        loadComponent: () => import('src/app/components/users/users.component')
          .then(c => c.UsersComponent),
        canActivate: [loggedIn, pageAccess('users')],
      },
      {
        path: 'approve-users',
        loadComponent: () => import('src/app/components/user-approve/user-approve.component')
          .then(c => c.UserApproveComponent),
        canActivate: [loggedIn, pageAccess('approve-users')],
      },
      {
        path: 'reports',
        loadComponent: () => import('src/app/components/reports/reports.component')
          .then(c => c.ReportsComponent),
        canActivate: [loggedIn, pageAccess('users')],
      },
      {
        path: 'medicinesCategories',
        loadComponent: () => import('src/app/components/medicines/medicines-categories/medicines-categories.component')
          .then(c => c.MedicinesCategoriesComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'groupsCategories',
        loadComponent: () => import('src/app/components/groups/groups-categories/groups-categories.component')
          .then(c => c.GroupsCategoriesComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'actionProducts/:type',
        loadComponent: () => import('src/app/components/action-products/action-products.component')
          .then(c => c.ActionProductsComponent),
        canActivate: [loggedIn],
      },
      /*{
        path: 'actionProducts',
        loadComponent: () => import('src/app/components/action-products/action-products.component')
          .then(c => c.ActionProductsComponent),
        canActivate: [loggedIn]
      },*/
      {
        path: 'conditionsCategories',
        loadComponent: () => import('src/app/components/conditions/conditions-categories/conditions-categories.component')
          .then(c => c.ConditionsCategoriesComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'groups',
        loadComponent: () => import('src/app/components/groups/groups.component')
          .then(c => c.GroupsComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'actions',
        loadComponent: () => import('src/app/components/actions/actions.component')
          .then(c => c.ActionsComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'scheduledPlans',
        loadComponent: () => import('./components/scheduler/scheduled-plans/scheduled-plans.component')
          .then(c => c.ScheduledPlansComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'scheduledInstances',
        loadComponent: () => import('./components/scheduler/scheduled-instances/scheduled-instances.component')
          .then(c => c.ScheduledInstancesComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'farms',
        loadComponent: () => import('src/app/components/farms/farms.component')
          .then(c => c.FarmsComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'conditions',
        loadComponent: () => import('src/app/components/conditions/conditions.component')
          .then(c => c.ConditionsComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'medicines',
        loadComponent: () => import('src/app/components/medicines/medicines.component')
          .then(c => c.MedicinesComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'meals',
        loadComponent: () => import('src/app/components/meals/meals.component')
          .then(c => c.MealsComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'processes',
        loadComponent: () => import('src/app/components/processes/processes.component')
          .then(c => c.ProcessesComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'products',
        loadComponent: () => import('src/app/components/products/products.component')
          .then(c => c.ProductsComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'breeds',
        loadComponent: () => import('src/app/components/breeds/breeds.component')
          .then(c => c.BreedsComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'dev',
        loadComponent: () => import('src/app/components/dev/dev.component')
          .then(c => c.DevComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'lots',
        loadComponent: () => import('src/app/components/lots/lots.component')
          .then(c => c.LotsComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'productsTemplates',
        loadComponent: () => import('src/app/components/products-templates/products-templates.component')
          .then(c => c.ProductsTemplatesComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'documents',
        loadComponent: () => import('src/app/components/documents/documents.component')
          .then(c => c.DocumentsComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'documentCategories',
        loadComponent: () => import('src/app/components/documents/document-categories/document-categories.component')
          .then(c => c.DocumentCategoriesComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'marketplace',
        loadComponent: () => import('src/app/components/marketplace/marketplace.component')
          .then(c => c.MarketplaceComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'config',
        loadComponent: () => import('src/app/components/config-page/config-page.component')
          .then(c => c.ConfigPageComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'fields',
        loadComponent: () => import('src/app/components/fields/fields.component')
          .then(c => c.FieldsComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'fieldActions',
        loadComponent: () => import('src/app/components/field-actions/field-actions.component')
          .then(c => c.FieldActionsComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'cows',
        loadComponent: () => import('src/app/components/cows/cows.component')
          .then(c => c.CowsComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'wallet',
        loadComponent: () => import('src/app/components/wallet-page/wallet-page.component')
          .then(c => c.WalletPageComponent),
        canActivate: [loggedIn],
      },
      {
        path: 'analysis',
        loadComponent: () => import('src/app/components/analysis/analysis.component')
          .then(c => c.AnalysisComponent),
        canActivate: [loggedIn],
      },
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];
